<template lang="pug">
div
  v-menu(v-model="show" rounded="lg" allow-overflow :close-on-content-click="false" offset-y max-height="345")
    template(#activator="{ on }")
      v-sheet.text-sm.round-lg.border-menu.clickable(v-on="on" flat outlined)
        v-row.py-1(no-gutters align="center" style="min-height: 38px;")
          v-col.pl-3
            .text-sm(v-if="selectedSegment") {{ selectedSegment.title }}
            .text-sm(v-else ) Choose segment
          v-col.shrink.pr-4(v-if="isFetching")
            v-progress-circular.ma-auto(:width="2" :size="15" color="primary" indeterminate)
          v-col.shrink.pr-4(v-else)
            v-icon(size=20 style="margin-top: 2px;") $yzi-chevron-down

    .text-xs.white
      .search-input
        v-text-field.mb-2.mx-4.text-sm.round-xl(v-model="itemName" outlined :placeholder="$t('search_or_add_new')" dense hide-details autofocus @keyup.enter="onAddItem")
        template(v-if="showAddButton")
          .text-xxs.px-4.italic.mb-2 Hit 
            span.font-semibold.danger500--text ENTER 
            | to add segment 
            span.font-semibold '{{ $options.filters.truncate(itemName, 35) }}' 
            | or click 
            span.font-semibold.clickable.underline(@click="onAddItem") HERE
        v-divider
      div.d-flex.justify-center(v-if="isFetching")
        v-progress-linear(:width="3" rounded color="primary" indeterminate)
      .d-flex.align-center.justify-space-between.px-4.py-3
        .font-semibold.mr-6 Existing segments
        y-pagination(v-model="page" :pageSize="pageSize" :count="totalCount" :loading="isFetching") 
      div(v-for="segment in segments" @click="onSelectItem(segment)")
        .d-flex.flex-column.py-3.px-4.hover-bg.clickable
          .text-sm {{ segment.title }}
          .text-xs.italic {{ segment.description }}
        v-divider
      template(v-if="!segments.length")
        .px-4.py-3 {{ $t('no_result_match') }}
</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    selectedSegment: {
      type: Object,
      default: null
    },
  },
  data: () => ({
    isLoading: false,
    isFetching: false,
    show: false,
    itemName: null,
    openDeleteConfirmationDialog: false,
    page: 1,
    pageSize: 20,
    totalCount: 0,
    segments: []
  }),
  watch: {
    show(val) {
      this.$emit('dropdownOpenClosed', val)
    },
    itemName () {
      this.searchStart()
    },
    page () {
      this.fetchSegments()
    }
  },
  mounted () {
    this.fetchSegments()
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    params () {
      return {
        page: this.page,
        page_size: this.pageSize,
        search: this.itemName || '',
        dynamic: false
      }
    },
    showAddButton() {
      if (this.itemName && this.segments.every(segment => segment.title.toLowerCase() !== this.itemName.toLowerCase())) {
        return true
      }
      return false
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    searchStart: debounce(function () {
      this.page = 1
      this.fetchSegments()
    }, 750),
    fetchSegments () {
      this.isFetching = true
      this.$axios.get(`/connect/${this.company.slug}/groups`, { params: this.params })
        .then(({ data }) => {
          this.segments = data.results
          this.totalCount = data.count
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    onSelectItem (item) {
      this.itemName = ''
      this.$emit('update:selectedSegment', item)
      this.show = false
    },
    async onAddItem () {
      this.isFetching = true
      const payload = {
        title: this.itemName
      }
      this.$axios.post(`/connect/${this.company.slug}/groups`, payload)
        .then(({ data }) => {
          this.onSelectItem(data)
          this.$emit('added', data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    }
  }
}
</script>

<style scoped>
.border-menu {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
.error-border-menu {
  border: 1px solid var(--v-danger500);
  box-shadow: none;
}
.search-input {
  position: sticky;
  top: 0px;
  background-color: #FFFFFF !important;
  border-color: #FFFFFF !important;
  z-index: 4;
  padding-top: 8px;
}
.disabled-item {
  background-color: var(--v-neutral300);
  color: var(--v-neutral500);
}
</style>